var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"upload-documents"},[_c('DocumentTaskTemplate',{attrs:{"directory-id":_vm.directoryId,"file-type":_vm.fileType,"is-case":_vm.isCase,"variant":"directory"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }